import antimicrobialUnitFragment from "./antimicrobialUnit";

const treatmentObjectFragment = `
{
    titleDisplay,
    complex,
    dose,
    duration,
    food,
    "complex": coalesce(complex, false), // TODO: In Sanity, make this false by default rather than giving a null value.
    frequency,
    administration,
    antimicrobialUnit->
      ${antimicrobialUnitFragment}
  }
`;

export default treatmentObjectFragment;
